export default {
  name: 'marking--treeMrkLoadKmFromDoc',
  apiService: 'shoes',
  apiPath: '/admin/mrk/func/loadKmFromDoc',
  urlParamName: 'marking--treeMrkLoadKmFromDoc',
}; 